import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PortalRouter from './components/PortalRouter';
import DevHelper from './components/DevHelper';
import config from './services/config';

function App() {
  const isDevelopment = process.env.NODE_ENV === 'development';

  // Load platform favicon from platform config (public endpoint, no auth needed)
  useEffect(() => {
    fetch(`${config.API_URL}/public/platform-config`)
      .then(res => res.json())
      .then(({ data }) => {
        const faviconUrl = data?.branding?.assets?.faviconUrl;
        if (faviconUrl) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
          }
          link.href = faviconUrl;
        }
      })
      .catch(() => {});
  }, []);

  return (
    <Router>
      <Routes>
        {/* Short URL route (new — /p/:shortCode) */}
        <Route path="/p/:shortCode/*" element={<PortalRouter />} />

        {/* Token-based route (backwards compatible — existing /t/ links) */}
        <Route path="/t/:token/*" element={<PortalRouter />} />

        {/* Legacy publicId route - can remove later */}
        <Route path="/portal/:publicId/*" element={<PortalRouter />} />
        
        {/* Development helper */}
        {isDevelopment && (
          <Route path="/dev" element={<DevHelper />} />
        )}
        
        {/* Default routes */}
        <Route path="/" element={isDevelopment ? <Navigate to="/dev" /> : <Navigate to="/not-found" />} />
        <Route path="*" element={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-4">Invoice Not Found</h1>
              <p className="text-gray-600">This invoice link is invalid or has expired.</p>
              {isDevelopment && (
                <p className="mt-4">
                  <a href="/dev" className="text-blue-600 hover:underline">
                    Go to Development Helper
                  </a>
                </p>
              )}
            </div>
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
